export default {
  'pl': {
    'PAID': 'Opłacona',
    'UNPAID': 'Nieopłacona'
  },
  'en': {
    'PAID': 'Paid',
    'UNPAID': 'Unpaid'
  },
  'de': {
    'PAID': 'Bezahlt',
    'UNPAID': 'Unbezahlt'
  },
  'fr': {
    'PAID': 'Payée',
    'UNPAID': 'Non payée'
  },
  'it': {
    'PAID': 'Pagata',
    'UNPAID': 'Non pagata'
  }
};
